import PropTypes from 'prop-types'
import { Input, FieldInputStylized } from '@elparking/components'
import styled from 'styled-components'

const TextAreaStylized = styled(FieldInputStylized)``

TextAreaStylized.propTypes = {
    ...FieldInputStylized.propTypes,
    rows: PropTypes.string.isRequired,
}

TextAreaStylized.defaultProps = {
    ...FieldInputStylized.defaultProps,
    rows: '3',
    height: 'auto',
    as: 'textarea',
}

class Textarea extends Input {
    static propTypes = {
        ...Input.propTypes,
        rows: PropTypes.string.isRequired,
    }
    static defaultProps = {
        ...Input.defaultProps,
        rows: '3',
        height: 'auto',
        inputComponent: TextAreaStylized,
    }
}

export default Textarea
